import GLightbox from 'glightbox';

export const lightbox = () => {

  GLightbox();

}
